import React from "react";
import * as S from "./styles";

export const BannerMusic: React.FC = () => {
  return (
    <S.Container>
      <S.DesktopBanner />
      <S.MobileBanner />
    </S.Container>
  );
};
